<div class="header">
  <div class="header-content">
    <button mat-icon-button (click)="toggleDrawer()" class="icon-white-bg">
      @if(this.drawerUtils.drawerState()) {
        <mat-icon>menu_open</mat-icon>
      }
      @else{
        <mat-icon>menu</mat-icon>
      }
    </button>
    <img routerLink="/dashboard" class="logo-size" [src]="logoSrc" alt="logo" />
  </div>
  <div class="center-user-content">
    {{ mail() }}
    <mat-icon class="logout-button" (click)="logout()">logout</mat-icon>
  </div>
</div>
